export const laboratoryConfig = {
  'hematología': {
    order: 1,
    title: 'HEMATOLOGÍA',
  },
  'bioquímica': {
    order: 2,
    title: 'BIOQUÍMICA',
  },
  'inmunología': {
    order: 3,
    title: 'INMUNOLOGÍA',
  },
  'microbiología': {
    order: 4,
    title: 'MICROBIOLOGÍA',
  },
  'toxicología': {
    order: 5,
    title: 'TOXICOLOGÍA',
  },
};
